import React from 'react';

import PropTypes from 'prop-types';
import { isArray } from 'lodash';

import { t } from '~/helpers';

import { Card } from '..';

// Serialize objects
function handleSerializeObject({
  codigotanquefisico,
  nomeproduto,
  corproduto,
  volumeespacovazioestoqueproduto,
  capacidadeoperacionaltanquefisico,
  volumeestoqueproduto,
  datahoraestoqueproduto,
}) {
  return {
    titulo: `${codigotanquefisico} - ${nomeproduto.toUpperCase()}` ,
    cor: corproduto,
    capacidade: capacidadeoperacionaltanquefisico,
    espacoVazio: volumeespacovazioestoqueproduto,
    saldo: volumeestoqueproduto,
    atualizacao: datahoraestoqueproduto,
  };
}

export default function List({ refresh, get, ...rest }) {
  return (
    <>
      {isArray(rest.produtos) &&
        rest.produtos.map((product) => (
          <Card
            refreshProduct={() =>
              refresh({ ...product, idposto: rest.idposto, read: () => get() })
            }
            station={handleSerializeObject(product)}
          />
        ))}
    </>
  );
}

List.propTypes = {
  refresh: PropTypes.func.isRequired,
  get: PropTypes.func.isRequired,
};
